import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth'
import logger from './logger'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

if (!firebaseConfig.apiKey) {
  logger.error(
    'Firebase API Key is missing. Make sure you have set VITE_FIREBASE_API_KEY in your .env file and restarted the development server.'
  )
} else {
  // logger.debug('Firebase Config Loaded:', {
  //   apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 5)}...` : 'undefined',
  //   authDomain: firebaseConfig.authDomain,
  //   projectId: firebaseConfig.projectId,
  // });
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

// Set persistence to LOCAL to maintain auth state across page refreshes
setPersistence(auth, browserLocalPersistence).catch((error) => {
  logger.error('Failed to set Firebase auth persistence:', error)
})

export const googleProvider = new GoogleAuthProvider()
